import React from 'react';
import { Facebook, Linkedin } from 'lucide-react';
import lanerunnerLogoFooter from '@/assets/lanerunner-logo-footer.png.asset.json';

const LandingFooter: React.FC = () => {
  return (
    <footer
      className="relative py-12 sm:py-16 px-4 sm:px-6 border-t border-white/10"
      style={{ backgroundColor: '#0A0E15' }}
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div className="col-span-2 md:col-span-1">
            <img src={lanerunnerLogoFooter.url} alt="LaneRunner" className="h-14 sm:h-16 mb-4" />
            <p className="text-gray-400 text-xs sm:text-sm">
              The transparent freight marketplace for carriers and brokers.
            </p>
          </div>

          <div>
            <h4 className="text-white mb-3 sm:mb-4 text-sm sm:text-base">Platform</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li><a href="/shippers" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">For Shippers</a></li>
              <li><a href="/brokers" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">For Brokers</a></li>
              <li><a href="/carriers" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">For Carriers</a></li>
              <li><a href="/lr-direct-access" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">LR Direct</a></li>
              <li><a href="/pricing" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">Pricing</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white mb-3 sm:mb-4 text-sm sm:text-base">Company</h4>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li><a href="/about" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">About Us</a></li>
              <li><a href="/support" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">Support</a></li>
              <li><a href="/investors" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">Investors</a></li>
              <li><a href="/affiliates" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">Affiliate Program</a></li>
              <li><a href="/privacy" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">Privacy Policy</a></li>
              <li><a href="/terms" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">Terms of Service</a></li>
              <li><a href="/cancellation-policy" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">Cancellation Policy</a></li>
              <li><a href="/cookies" className="text-gray-400 hover:text-[#1ab7aa] transition-colors">Cookie Policy</a></li>
              <li>
                <button
                  type="button"
                  onClick={() => window.dispatchEvent(new Event('lr-open-cookie-settings'))}
                  className="text-gray-400 hover:text-[#1ab7aa] transition-colors text-left"
                >
                  Cookie Preferences
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white mb-3 sm:mb-4 text-sm sm:text-base">Connect</h4>
            <div className="flex gap-3 sm:gap-4">
              <a href="https://www.facebook.com/lanerunnerapp" target="_blank" rel="noopener noreferrer" aria-label="LaneRunner on Facebook" className="text-gray-400 hover:text-[#1ab7aa] transition-colors"><Facebook className="w-4 sm:w-5 h-4 sm:h-5" /></a>
              <a href="https://www.linkedin.com/company/lanerunner-logistics" target="_blank" rel="noopener noreferrer" aria-label="LaneRunner on LinkedIn" className="text-gray-400 hover:text-[#1ab7aa] transition-colors"><Linkedin className="w-4 sm:w-5 h-4 sm:h-5" /></a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 sm:pt-8 text-center text-gray-500 text-xs sm:text-sm space-y-2">
          <div>
            Powered by <span className="font-semibold text-[#1ab7aa]">ATLAS</span> AI
          </div>
          <div>© 2026 LaneRunner. All rights reserved. Built for freight professionals who demand transparency.</div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
